/* Surisa <home-hero-carousel> — carrusel del hero de la homepage.
   Auto-avance lateral cada N ms (data-interval), con dots de paginación
   clicables. Pausa con prefers-reduced-motion, al pasar el ratón por
   encima y cuando la pestaña no está visible. Sin dependencias. */
(function () {
  class HomeHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.track  = this.querySelector('.home-hero__track');
      this.slides = this.querySelectorAll('.home-hero__slide');
      this.dots   = Array.prototype.slice.call(this.querySelectorAll('.home-hero__dot'));
      this.count  = this.slides.length;
      this.index  = 0;
      this.timer  = null;
      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 1000;
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.count <= 1) return;

      this._onDot   = this.onDot.bind(this);
      this._onVis   = this.onVis.bind(this);
      this._onEnter = this.stop.bind(this);
      this._onLeave = this.start.bind(this);

      this.dots.forEach(function (d) { d.addEventListener('click', this._onDot); }, this);
      this.go(0);

      if (!this.reduce) {
        this.addEventListener('mouseenter', this._onEnter);
        this.addEventListener('mouseleave', this._onLeave);
        document.addEventListener('visibilitychange', this._onVis);
        this.start();
      }
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this._onVis);
    }

    onDot(e) {
      var i = parseInt(e.currentTarget.getAttribute('data-index'), 10) || 0;
      this.go(i);
      this.restart();
    }

    onVis() {
      if (document.hidden) { this.stop(); } else { this.start(); }
    }

    go(i) {
      this.index = ((i % this.count) + this.count) % this.count;
      if (this.track) {
        this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
      }
      this.dots.forEach(function (d, di) {
        var on = di === this.index;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      }, this);
    }

    next() { this.go(this.index + 1); }

    start() {
      if (this.reduce || this.timer || this.count <= 1) return;
      var self = this;
      this.timer = setInterval(function () { self.next(); }, this.interval);
    }

    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    restart() { this.stop(); this.start(); }
  }

  if (!customElements.get('home-hero-carousel')) {
    customElements.define('home-hero-carousel', HomeHeroCarousel);
  }
})();
